import type { TAppState } from '../../types/appState';
import type { IChatProfile } from '../../types/chatProfile';
import { currentOpenChatIDSelector } from '../currentOpenChatIDSelector';

export const userProfileSelector = (state: TAppState): IChatProfile | null => {
  const chatId = currentOpenChatIDSelector(state);

  if (!chatId) {
    return null;
  }

  return state.userProfile[chatId] ?? null;
};
